export const ERROR_GAS_TOO_LOW = 0;
export const ERROR_COMMON = 1;
export const ERROR_UNDERPRICED_REPLACEMENT_TRX = 2;
export const ERROR_PROVIDER_GAS = 3;